import Vue from 'vue';

document.addEventListener("DOMContentLoaded", function () {
    window.ve = readyForVue(data_ve);
});

function readyForVue(data_ve) {

    return new Vue({
        el: '#mainContents',
        data: function() {
            return Object.assign({}, data_ve, {
                errors: [],
            });
        },
        mounted: function() {
            const params = new URLSearchParams(location.search);
            this.errors = params.getAll("error");
        },
        methods: {
            returnToHotelUrl: function() {
                window.location.href = this.hotelUrl;
            }
        }
    });
}